// extracted by mini-css-extract-plugin
module.exports = {"page":"SigninCompletePage_page__1TBXP","title":"SigninCompletePage_title__2rvML"};